import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { LoaderService } from '../../../core/services/loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    .loader-backdrop {
      position: fixed;
      inset: 0;
      z-index: 9998;
      background: rgba(255, 255, 255, 0.55);
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: none;
    }
    .comet {
      width: 36px;
      height: 36px;
      position: relative;
      animation: spin 1.2s linear infinite;
    }
    .arc-outer {
      position: absolute;
      inset: 0;
      border-radius: 50%;
      border: 3px solid transparent;
      border-top-color: #025188;
      border-right-color: #025188;
    }
    .arc-inner {
      position: absolute;
      inset: 6px;
      border-radius: 50%;
      border: 2px solid transparent;
      border-bottom-color: #0370bb;
      border-left-color: #0370bb;
      animation: counter 1.2s linear infinite;
    }
    @keyframes spin    { to { transform: rotate(360deg); } }
    @keyframes counter { to { transform: rotate(-360deg); } }
  `],
  template: `
    @if (loaderService.isLoading()) {
      <div class="loader-backdrop" role="status" aria-label="Loading">
        <div class="comet">
          <div class="arc-outer"></div>
          <div class="arc-inner"></div>
        </div>
      </div>
    }
  `,
})
export class LoaderComponent {
  readonly loaderService = inject(LoaderService);
}
